import { QidProductDocument } from "server/models"

export interface QidProductDocumentList { [fileId: number]: QidProductDocument }

export interface QidProductDocumentState {
    documentList: QidProductDocumentList
    documentIds: number[]

    reloadList: boolean
}

export const QID_PRODUCT_DOCUMENT_LIST = "QID_PRODUCT_DOCUMENT_LIST"
export const QID_PRODUCT_DOCUMENT_RELOAD_LIST = "QID_PRODUCT_DOCUMENT_RELOAD_LIST"
